module.exports = __webpack_public_path__ + "img/levelchangedown.18fcdb9e.svg";